import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useApp } from "@/contexts/AppContext";
import { Button } from "@/components/ui/button";
import { BadgeCheck, Building2, FileCheck2, CalendarDays, ArrowRight, MapPin } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1591604129939-f1efa4d9f7fa?w=1200";

export default function AboutPage() {
  const { t } = useApp();
  const nav = useNavigate();
  const [s, setS] = useState(null);
  const [gallery, setGallery] = useState([]);
  useEffect(() => {
    api.get("/public/catalog").then((r) => setS(r.data.settings));
    api.get("/public/gallery").then((r) => setGallery(r.data.items)).catch(() => {});
  }, []);
  if (!s) return <div className="py-20 text-center text-slate-500">{t("loading")}</div>;
  const legal = [
    { i: BadgeCheck, l: t("legal_nusuk"), v: s.legal_nusuk },
    { i: Building2, l: t("legal_cr"), v: s.legal_cr },
    { i: FileCheck2, l: t("legal_license"), v: s.legal_license },
    { i: CalendarDays, l: t("founded"), v: s.founded_year },
  ];
  return (
    <div data-testid="about-page">
      <section className="abdan-hero-grid">
        <div className="max-w-7xl mx-auto px-4 md:px-8 pt-16 pb-20 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <div className="text-xs uppercase tracking-widest text-emerald-700 font-bold mb-3">{t("about_us")}</div>
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900 leading-tight">{s.company_name}</h1>
            <p className="text-lg text-slate-600 mt-6 leading-relaxed" data-testid="about-text">{s.about_text}</p>
            <div className="flex items-center gap-2 text-slate-600 mt-4 text-sm"><MapPin className="w-4 h-4 text-emerald-600" />{s.company_address}</div>
            <Button onClick={() => nav("/booking")} size="lg" className="bg-emerald-600 hover:bg-emerald-700 rounded-full px-8 mt-8" data-testid="about-book">{t("book_now")} <ArrowRight className="w-4 h-4 ml-2" /></Button>
          </div>
          <img src={s.images?.about_hero || gallery[0]?.url || HERO} alt="Abdan Pro" className="rounded-3xl shadow-2xl w-full h-[400px] object-cover" />
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 md:px-8 py-20">
        <div className="mb-10"><div className="text-xs uppercase tracking-widest text-emerald-700 font-bold mb-2">{t("legality")}</div>
          <h2 className="text-3xl sm:text-4xl font-bold">{t("legality_title")}</h2></div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="legal-grid">
          {legal.map((x, i) => { const I = x.i;
            return (<div key={i} className="abdan-card p-6"><div className="w-11 h-11 rounded-xl bg-emerald-50 text-emerald-700 grid place-items-center mb-4"><I className="w-5 h-5" /></div>
              <div className="text-xs uppercase tracking-widest text-slate-500">{x.l}</div><div className="font-bold mt-1">{x.v || "-"}</div></div>);
          })}
        </div>
      </section>
      <section className="bg-slate-50 py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="mb-10"><div className="text-xs uppercase tracking-widest text-emerald-700 font-bold mb-2">{t("gallery")}</div>
            <h2 className="text-3xl sm:text-4xl font-bold">{t("gallery_title")}</h2></div>
          {gallery.length === 0 ? <div className="text-slate-500" data-testid="gallery-empty">{t("gallery_empty")}</div> : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="gallery-grid">
              {gallery.map((g, i) => (
                <figure key={g.id} className={`abdan-card overflow-hidden group ${i === 0 ? "sm:col-span-2 sm:row-span-2" : ""}`} data-testid={`gallery-${g.id}`}>
                  <img src={g.url} alt={g.caption || "Galeri"} className={`w-full object-cover group-hover:scale-105 transition duration-500 ${i === 0 ? "h-full min-h-[300px]" : "h-56"}`} />
                  {g.caption && <figcaption className="p-3 text-sm text-slate-600">{g.caption}</figcaption>}
                </figure>))}
            </div>)}
        </div>
      </section>
    </div>
  );
}
